<pda-base>
   <div class="pda-home">
        <pda-carousel [slides]="slides"></pda-carousel>
   </div>
</pda-base>